// export const SERVER_URL = "https://stage.v2.karafsapp.com";
// export const SERVER_URL = "https://stage.api.karafshealth.com";
export const SERVER_URL = "https://api.karafshealth.com";
// export const SERVER_URL = "";
